import { useNavigate } from "react-router-dom";
import GrabProvider from "./../../layout/v6/GrabProvider";
import { useGetBusinessesFavoriteQuery } from "./../../services/apiSlice";

const Brand = () => {
  const { data } = useGetBusinessesFavoriteQuery();

  const navigate = useNavigate();

  return (
    <div className="w-full max-w-[368px] flex flex-col gap-6">
      <h5 className="text-primary font-[Figtree] text-xl font-bold not-italic leading-none">
        Brands
      </h5>
      <GrabProvider>
        {(data?.data || []).slice(0, 10).map((item) => (
          <article
            key={item.id}
            onClick={() => navigate(`/quest/business/${item.id}`)}
            className="flex flex-col w-[130px] max-xs:w-[90px] flex-shrink-0 rounded-md cursor-pointer gap-1.5"
          >
            <div
              className="h-auto w-full self-stretch aspect-square rounded-md border border-light-grey bg-cover bg-center"
              style={{
                backgroundImage: item.avatar_data
                  ? `url(${process.env.REACT_APP_URL_IMAGE}/${item.avatar_data.file_path})`
                  : `url("/images/brand.jpg")`,
              }}
            />

            <div className="flex flex-col justify-center items-start self-stretch gap-[3px]">
              <span
                className="text-dark-gray text-[14px] font-medium leading-[18px] line-clamp-2"
                title={item.company_name || ""}
              >
                {item.company_name || "Business Name"}
              </span>
            </div>
          </article>
        ))}
      </GrabProvider>
    </div>
  );
};

export default Brand;
